import type { IconProps } from './IconProps';

export const CoinbaseIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_824_15091)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C12.4187 16 16 12.4187 16 8ZM5.18906 8C5.18906 9.55469 6.44844 10.8125 8.00156 10.8125C9.39375 10.8125 10.5469 9.79688 10.7703 8.46875H13.6047C13.3656 11.3562 10.9484 13.625 8 13.625C4.89375 13.625 2.375 11.1062 2.375 8C2.375 4.89375 4.89375 2.375 8 2.375C10.9484 2.375 13.3656 4.64375 13.6047 7.53125H10.7719C10.55 6.20312 9.39375 5.1875 8.00156 5.1875C6.44844 5.1875 5.18906 6.44531 5.18906 8Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_824_15091">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
